const CustomContextMenu = ({ visible, menuPosition, options }) => {
  if (!visible) return null;

  const { x, y } = menuPosition;

  const menuStyle = {
    top: `${y}px`,
    left: `${x}px`,
  };

  return (
    <ul id="context-menu" className="context-menu" style={menuStyle}>
      {options.map((option, index) => (
        <li key={index} onClick={option.onClick}>
          {option.label}
        </li>
      ))}
    </ul>
  );
};

export default CustomContextMenu;
